
import { environmentHttpClient } from "client/Api/httpClient";
import { AppointmentViewModel } from "client/Api/Calendar/calendar";

export type AvailableCalendarModel = {
	id: string;
	name: string;
};

export function getAvailableCalendars(
	signal?: AbortSignal
): Promise<AvailableCalendarModel[]> {
	return environmentHttpClient.get<AvailableCalendarModel[]>(
		"/Workspace/LiveInformation/Calendar/List",
		{},
		{ signal }
	);
}

export function getAppointments(filters: AppointmentsFilter[]): Promise<AppointmentsResult[]> {
	return environmentHttpClient.post<AppointmentsResult[]>(
		"Workspace/LiveInformation/Calendar/GetAppointments",
		filters
	);
}

export function listPreferences(
	signal?: AbortSignal
): Promise<CalendarTilePreferenceModel[]> {
	return environmentHttpClient.get<CalendarTilePreferenceModel[]>(
		"/Workspace/LiveInformation/Calendar/Preferences",
		undefined,
		{ signal }
	);
}

export function setPreference(
	tileId: number,
	model: SetCalendarTilePreferenceModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		`/Workspace/LiveInformation/Calendar/Preferences/${tileId}`,
		model,
		{ signal }
	);
}

export type AppointmentsSpan = {
	start: string;
	end: string;
};

export type AppointmentsFilter = {
	id: string;
	upcomingAppointments: boolean;
	customDateSpans: readonly AppointmentsSpan[];
};

export enum AppointmentsLoadStatus {
	NoError = 0,
	UnknownError = 1,
	AccessDenied = 2
}

export type AppointmentsSuccessfulResult = {
	status: AppointmentsLoadStatus.NoError;
	id: string;
	upcomingAppointments: readonly AppointmentViewModel[];
	appointmentsFromRequestedSpans: readonly AppointmentViewModel[];
};

export type AppointmentsErrorResult = {
	status: Exclude<AppointmentsLoadStatus, AppointmentsLoadStatus.NoError>;
	id: string;
};

export type AppointmentsResult = AppointmentsSuccessfulResult | AppointmentsErrorResult;

export type CalendarTilePreferenceModel = {
	tileId: number;
	calendarId: string;
};

export type SetCalendarTilePreferenceModel = {
	calendarId: string;
};
